import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { signInEmailStart } from '../../../api/methods/auth';
import { Button, TextFieldForm } from '../../common';
import { ERROR_MESSAGE_GENERIC } from '../../../constants/common';
import { SIGN_IN_FORM_VALIDATION_SCHEMA } from '../../../constants/forms';
import { SignInEmailFormData } from '../../../types/forms';

type EmailFormProps = {
  onSuccess: (email: string) => void;
};

const EmailForm = ({ onSuccess }: EmailFormProps) => {
  const [error, setError] = useState<boolean>(false);

  const { register, handleSubmit, formState } = useForm<SignInEmailFormData>({
    resolver: yupResolver(SIGN_IN_FORM_VALIDATION_SCHEMA),
  });

  const onSubmit = handleSubmit(async ({ email }) => {
    await signInEmailStart(email)
      .then(() => onSuccess(email))
      .catch(() => setError(true));
  });

  if (error) {
    return <span>{ERROR_MESSAGE_GENERIC}</span>;
  }

  return (
    <form onSubmit={onSubmit}>
      <TextFieldForm
        {...register('email')}
        type="email"
        placeholder="Email Address"
        className="w-full mb-5"
        error={formState?.errors?.email}
      />

      <Button type="submit" className="w-full">
        {formState.isSubmitting ? 'Signing in...' : 'Sign in'}
      </Button>
    </form>
  );
};

export default EmailForm;
